import * as React from 'react';
import { StyledHeader } from './StyledHeader';
import { ClydeLogoLink, LogoLinkOptions } from 'src/components/Shared/ClydeLogoLink';
import Button from 'src/components/Button';
import { ReactComponent as InfoIcon } from 'src/images/info-icon.svg';
import { ContractDetailsRequestedPromptOptions } from 'src/types/IModal';
import { LearnMoreButton } from '../Footer/StyledFooter';

export enum HeaderPromptTypes {
  DROPDOWN = 'dropdown',
  LIST = 'list',
  RADIO = 'radio',
  SELECT = 'select',
  VALUEPROP = 'valueprop',
}

interface IHeaderProps {
  children?: React.ReactNode;
  promptType: HeaderPromptTypes; // TODO: avoid prop-drilling just for data-test attributes
  isMobile?: boolean;
  showLearnMore?: boolean;
  learnMoreLink?: string;
  onInfoIconClick?: () => void;
  contractDetailsRequested?: (prompt: ContractDetailsRequestedPromptOptions) => void;
  // TODO: Should isMobile come directly from 'react-device-detect'? If so, it will apply to every prompt
}

export const Header = ({
  children,
  promptType,
  isMobile = false,
  showLearnMore = false,
  learnMoreLink = '',
  onInfoIconClick,
  contractDetailsRequested,
}: IHeaderProps) => (
  <StyledHeader data-test={`product-page-header-${promptType}`} isMobile={isMobile}>
    <div className='headline'>
      <ClydeLogoLink
        data-test={`clyde-logo-${promptType}`}
        logoType={LogoLinkOptions.SHIELD}
      />
      <span data-test={`product-page-text-${promptType}`} className="prompt-text">
        {children}
      </span>
      {showLearnMore && (
        <LearnMoreButton
          data-test="whats-covered"
          className="learn-more-btn"
          onClick={() => contractDetailsRequested?.(ContractDetailsRequestedPromptOptions.RADIO)}
          type="button"
        >
          {learnMoreLink}
        </LearnMoreButton>
      )}
    </div>
    {onInfoIconClick && (
      <Button className='info-icon' onClick={onInfoIconClick} type='button'>
        <InfoIcon />
      </Button>
    )}
  </StyledHeader>
);
